export default {
    install(Vue) {
        Vue.mixin({
            data(){
                return {
                    clickBtuuonRepeat: false,
                    isShowArr: ['pdf.njzrt.net'],
                    isShowArrData:[
                        {url:'pdf.njzrt.net',lxr:'陈老师',phone:'15026448220',site:'江苏省南京市江宁区秣陵街道诚信大道998号星光名座广场05幢510室  ',name:'南京昭锐汀网络科技有限公司'},
                    ],
                    footerCompany: ['pdf.njzrt.net'],
                    matchHostArr : [
                        { host: 'pdf.njzrt.net', name: '南京昭锐汀网络科技有限公司' },
                      ],
                }
            },
            methods:{

                //将url转成对象
                parseQueryString(url) {
                    //url参数转对象
                    url = !url ? window.location.href : url
                    if (url.indexOf('?') === -1) {
                    return null
                    }
                    let search = url[0] === '?' ? url.substr(1) : url.substring(url.lastIndexOf('?') + 1)
                    if (search === '') {
                    return null
                    }
                    search = search.split('&')
                    let query = {}
                    for (let i = 0; i < search.length; i++) {
                    let pair = search[i].split('=')
                    // query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '')
                    query[pair[0]] = pair[1] || ''
                    }
                    return query
                },

                isToPdf(){

                }
            }
        })
    }
}